import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

type PyramidPlaceholderProps = DefaultIconProps & {
  variant?: 'mobile' | 'default';
};

export const PyramidPlaceholder = ({
  variant = 'default',
  width,
  marginLeft,
  marginRight,
  containerSize,
}: PyramidPlaceholderProps) =>
  variant === 'default' ? (
    <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 614 360">
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <path
                fill="#006474"
                d="M74.857 108.702L0 245.21 614 245.21 539.145 108.702z"
                transform="translate(-77 -1096) translate(77 1096)"
              />
              <path
                fill="#FFF"
                d="M311.162 2.935c-1.048-1.858-2.405-2.75-3.777-2.91-1.64-.19-3.305.711-4.546 2.91l-54.355 96.347h117.033L311.162 2.935zM490.147 352.649l-55.191-97.353h-74.844L418.804 360h66.99c4.695 0 6.67-3.244 4.353-7.352M344.04 255.296H178.68l-54.834 97.195c-2.29 4.059-.358 7.35 4.329 7.35H402.95L344.04 255.297z"
                opacity=".6"
                transform="translate(-77 -1096) translate(77 1096)"
              />
            </g>
          </g>
        </g>
      </svg>
    </DefaultIconWrapper>
  ) : (
    <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width="100%">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335 197">
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <g>
                <path
                  fill="#006474"
                  d="M40.842 59.308L0 133.787 335 133.787 294.159 59.308z"
                  transform="translate(-20 -1198) translate(20 1198)"
                />
                <path
                  fill="#FFF"
                  d="M169.77 1.602C169.2.588 168.459.1 167.71.013c-.894-.103-1.803.389-2.48 1.589l-29.657 52.567h63.854L169.77 1.602zM267.425 192.406l-30.112-53.116h-40.835l32.022 57.127h36.55c2.562 0 3.64-1.77 2.375-4.01M187.709 139.29h-90.22L67.57 192.32c-1.249 2.214-.195 4.01 2.362 4.01h149.919l-32.142-57.04z"
                  opacity=".6"
                  transform="translate(-20 -1198) translate(20 1198)"
                />
              </g>
              <g transform="translate(-20 -1198) translate(20 1198) translate(175 13)">
                <circle cx="11" cy="11" r="11" fill="#006474" stroke="#CADED8" strokeWidth="2" />
                <text fill="#FFF" fontFamily="MyriadPro-Bold, Myriad Pro" fontSize="14" fontWeight="bold">
                  <tspan x="9.082" y="16">
                    i
                  </tspan>
                </text>
              </g>
              <g transform="translate(-20 -1198) translate(20 1198) translate(196 156)">
                <circle cx="11" cy="11" r="11" fill="#006474" stroke="#CADED8" strokeWidth="2" />
                <text fill="#FFF" fontFamily="MyriadPro-Bold, Myriad Pro" fontSize="14" fontWeight="bold">
                  <tspan x="9.082" y="16">
                    i
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </DefaultIconWrapper>
  );
